import { sentryAPIErrorV2 } from "./module_common";

export const feedbackLikedModalSelector = "#likedFeedbackModal";
export const feedbackDislikedModalSelector = "#dislikedFeedbackModal";
const formSelector = ".topic-form";
const formSubmitSelector = "button.form-submit";
const formCardSelector = ".element-form.topic-el";
const topicInputClass = "topic-input";
const formInputSelector = "." + topicInputClass;
const likeFormCardSelector = [feedbackLikedModalSelector, formCardSelector].join(" ");
const likedInputSelector = [feedbackLikedModalSelector, formInputSelector].join(" ");
const likedFormSubmitSelector = [feedbackLikedModalSelector, formSubmitSelector].join(" ");
const dislikeFormCardSelector = [feedbackDislikedModalSelector, formCardSelector].join(" ");
const dislikedInputSelector = [feedbackDislikedModalSelector, formInputSelector].join(" ");
const dislikedFormSubmitSelector = [feedbackDislikedModalSelector, formSubmitSelector].join(" ");

let params = {
    sendContentLike: ()=>{},
    sendContentDislike: ()=>{},
};

function attachLikeFormCardClick(){
    $(likeFormCardSelector).click(function(event){
        const target = $(event.target)
        const el = $(event.currentTarget)
        if (!target.hasClass(topicInputClass)){
            event.preventDefault()
            const inputEl = $(el.find("input"))[0]
            toggleChecked(inputEl)
        }
        el.toggleClass("active")
        if (likeFormIsChanged()){
            $(likedFormSubmitSelector).addClass("active")
        }else{
            $(likedFormSubmitSelector).removeClass("active")
        }
    })
}

function attachDislikeFormCardClick(){
    $(dislikeFormCardSelector).click(function(event){
        const target = $(event.target)
        const el = $(event.currentTarget)
        if (!target.hasClass(topicInputClass)){
            event.preventDefault()
            const inputEl = $(el.find("input"))[0]
            toggleChecked(inputEl)
        }
        el.toggleClass("active")
        if (dislikeFormIsChanged()){
            $(dislikedFormSubmitSelector).addClass("active")
        }else{
            $(dislikedFormSubmitSelector).removeClass("active")
        }
    })
}

function toggleChecked(el){
    if (el.checked){
        el.checked = false
    }else{
        el.checked = true
    }
}

function likeFormIsChanged(){
    const formData = getFormData(likedInputSelector)
    return formData.some(formEl => formEl.val);
}

function dislikeFormIsChanged(){
    const formData = getFormData(dislikedInputSelector)
    return formData.some(formEl => formEl.val);
}

function getFormData(classSelector){
    const data = []
    $(classSelector).each(function(){
        const el = $(this)[0]
        data.push({'id': el.id, 'val': el.checked})
    })
    return data
}

function attachLikeFormSubmit(){
    $(feedbackLikedModalSelector + " form").submit(function( event ) {
        event.preventDefault();
        if (!$(likedFormSubmitSelector).hasClass('active')) return
        const data = getFormData(likedInputSelector)
        sendLikeCategoryForm(data)
      });
}

function attachDislikeFormSubmit(){
    $(feedbackDislikedModalSelector + " form").submit(function( event ) {
        event.preventDefault();
        if (!$(dislikedFormSubmitSelector).hasClass('active')) return
        const data = getFormData(dislikedInputSelector)
        sendDislikeCategoryForm(data)
      });
}

function sendLikeCategoryForm(data){
    const selectedIds = []
    for(const idx in data){
        if (data[idx].val) selectedIds.push(Number(data[idx].id))
    }
    params.sendContentLike(getContentId(), selectedIds)
        .then(() => {
            $(feedbackLikedModalSelector).modal('hide')
        })
        .catch(err => {
            const contextData = {
                functiondata:{
                    function: "sendLikeCategoryForm",
                    err: err,
                    uid: UIDg,
                }
            }
            const error = new Error('Error sending book like feedback')
            error.name = 'sendLikeCategoryForm fail'
            sentryAPIErrorV2(error, contextData)
        })
}

function sendDislikeCategoryForm(data){
    const selectedIds = []
    for(const idx in data){
        if (data[idx].val) selectedIds.push(Number(data[idx].id))
    }
    params.sendContentDislike(getContentId(), selectedIds)
        .then(() => {
            $(feedbackDislikedModalSelector).modal('hide')
        })
        .catch(err => {
            const contextData = {
                functiondata:{
                    function: "sendDislikeCategoryForm",
                    err: err,
                    uid: UIDg,
                }
            }
            const error = new Error('Error sending book dislike feedback')
            error.name = 'sendDislikeCategoryForm fail'
            sentryAPIErrorV2(error, contextData)
        })
}

const getContentId = function(){
    return $(formSelector).data('contid')
}

export function initFeedback(initParams){
    params = initParams
    attachDislikeFormCardClick()
    attachDislikeFormSubmit()
    attachLikeFormCardClick()
    attachLikeFormSubmit()
}